import React, { createContext, useContext, useState, useEffect } from "react";
import { login as apiLogin, logout as apiLogout } from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  // Restore session from localStorage on page refresh
  useEffect(() => {
    const token      = localStorage.getItem("edu_token");
    const storedUser = localStorage.getItem("edu_user");
    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (_) {
        localStorage.removeItem("edu_user");
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      // Calls POST /api/v1/auth/login on Spring Boot backend
      const res = await apiLogin({ email, password });
      localStorage.setItem("edu_token", res.token);
      localStorage.setItem("edu_user", JSON.stringify(res.user));
      setUser(res.user);
      return { success: true };
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Invalid email or password";
      return { success: false, message };
    }
  };

  const logout = async () => {
    localStorage.removeItem("edu_token");
    localStorage.removeItem("edu_user");
    setUser(null);
    try { await apiLogout(); } catch (_) {}
  };

  // Spring Boot returns role as "TEACHER" / "ADMIN" (uppercase)
  const isTeacher =
    user?.role === "TEACHER" ||
    user?.role === "ADMIN"   ||
    user?.role === "teacher" ||
    user?.role === "admin";

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isTeacher }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
